import axios, { AxiosResponse } from 'axios';
import api from '../api';
import facebook from './facebook';
import youtube from './youtube';

const wowzaApi = axios.create({
  baseURL: process.env.VUE_APP_WOWZA_API_URL,
  headers: {
    Authorization: process.env.VUE_APP_WOWZA_API_HEADER_AUTHORIZATION,
    Application: process.env.VUE_APP_WOWZA_API_HEADER_APPLICATION,
  },
});

const deleteService = async (
  serviceId: number | string,
): Promise<AxiosResponse<Services.LiveSocial.Response.DeleteService>> => (
  api.delete(`livesocial/${serviceId}`)
);

const deleteUserAccount = async (
  accountId: number | string,
): Promise<AxiosResponse<Services.LiveSocial.Response.DeleteUserAccount>> => (
  api.delete(`social-users/${accountId}`)
);

const getLiveSocialGeneral = async (
  payload: Services.LiveSocial.GetLiveSocialGeneral,
): Promise<AxiosResponse<Services.LiveSocial.Response.GetLiveSocialGeneral>> => (
  api.get(`livesocialgeneral_get/${payload.customer_plans_id}/${payload.customer_plans_events_id}`)
);

const getServices = async (
  payload: Services.LiveSocial.GetServices,
): Promise<AxiosResponse<Services.LiveSocial.Response.GetServices>> => (
  api.get(`livesocial/${payload.plan_id}/${payload.event_id}/1/50/provider/${payload.provider}`)
);

const getUserAccountByUserId = async (
  payload: Services.LiveSocial.GetUserAccountByUserId,
): Promise<AxiosResponse<Services.LiveSocial.Response.GetUserAccountByUserId>> => {
  const { customerPlansEventsId, customerPlansId, userId } = payload;

  return api.get(`social-users-user-id/${userId}/${customerPlansId}/${customerPlansEventsId}`);
};

const getUserAccounts = async (
  payload: Services.LiveSocial.GetUserAccounts,
): Promise<AxiosResponse<Services.LiveSocial.Response.GetUserAccounts>> => {
  const { customerPlansEventsId, customerPlansId, provider } = payload;

  return api.get(`social-users/${provider}/${customerPlansId}/1/50/${customerPlansEventsId}`);
};

const postLiveSocialGeneral = async (
  payload: Services.LiveSocial.PostLiveSocialGeneral,
): Promise<AxiosResponse<Services.LiveSocial.Response.PostLiveSocialGeneral>> => (
  api.post('livesocialgeneral', payload)
);

const postService = async (
  payload: Services.LiveSocial.PostService,
): Promise<AxiosResponse<Services.LiveSocial.Response.PostService>> => (
  api.post('livesocial', payload)
);

const postUserAccount = async (
  payload: Services.LiveSocial.PostUserAccount,
): Promise<AxiosResponse<Services.LiveSocial.Response.PostUserAccount>> => (
  api.post('social-users', { ...payload, expirate: '5184000' })
);

const putLiveSocialGeneral = async (
  payload: Services.LiveSocial.PutLiveSocialGeneral,
): Promise<AxiosResponse<Services.LiveSocial.Response.PutLiveSocialGeneral>> => (
  api.put(`livesocialgeneral/${payload.id}`, payload)
);

const putService = async (
  payload: Services.LiveSocial.PutService,
): Promise<AxiosResponse> => (
  api.put(`livesocial/${payload.id}`, payload)
);

// wowza api calls

const deleteWowzaTarget = async (
  payload: Services.LiveSocial.DeleteWowzaTarget,
): Promise<AxiosResponse> => {
  const { application, server, streamtargetname } = payload;

  return wowzaApi.delete(`wowza/streamtarget/remove/${server}/${application}/${streamtargetname}`);
};

const postWowzaTarget = async (
  payload: Services.LiveSocial.PostWowzaTarget,
): Promise<AxiosResponse> => (
  wowzaApi.post('wowza/streamtarget/create', payload)
);

const liveSocial = {
  deleteService,
  deleteUserAccount,
  deleteWowzaTarget,
  getLiveSocialGeneral,
  getServices,
  getUserAccountByUserId,
  getUserAccounts,
  postLiveSocialGeneral,
  postService,
  postUserAccount,
  postWowzaTarget,
  putLiveSocialGeneral,
  putService,
  facebook,
  youtube,
};

export default liveSocial;
